<template>
	<AppFieldNumeric
		:id="context.id"
		v-model="enteredValue"
		:precision="2"
		:class="context.classes.input"
		:value-type="ValueType.Currency"
		:required="Boolean(context.required)"
		:disabled="Boolean(context.disabled)"
		prefix="€"
		wrapper-class="regular"
	/>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { formatNumeric, stringIsValue } from "@/helpers/inputHelpers";
import type { FormKitFrameworkContext } from "@formkit/core";
import { ValueType } from "@/enums/ValueType";

const props = defineProps<{
	context: FormKitFrameworkContext;
}>();

const enteredValue = ref<number | undefined>();

function enteredToHdn(entered?: number) {
	return formatNumeric(entered, 2, 2, false)?.replace?.(",", ".");
}

function hdnToEntered(input?: string) {
	return stringIsValue(
		typeof input === "string" ? input?.replace?.(".", ",") : input,
	);
}

const data = computed(() => props.context.value);

watch(
	data,
	(newValue, oldValue) => {
		if (hdnToEntered(newValue) === hdnToEntered(oldValue)) {
			return;
		}

		enteredValue.value = hdnToEntered(newValue);
	},
	{ immediate: true },
);

watch(enteredValue, async (newValue, oldValue) => {
	if (newValue === undefined) {
		await props.context.node.input(undefined);
		return;
	}

	if (newValue === oldValue) {
		return;
	}

	const newHdnValue = enteredToHdn(newValue);
	const oldHdnValue = enteredToHdn(oldValue);

	if (newHdnValue === oldHdnValue) {
		return;
	}

	await props.context.node.input(newHdnValue);
});
</script>
